export default [
  {
    label: '團購',
    value: 'groupPurchase',
  },
  {
    label: '自費戶訂購',
    value: 'individualPurchase',
  },
  {
    label: '系統後台',
    value: 'app',
  },
];
